import * as React from "react";
const SvgCameraAlt = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 3,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.83 4 15 2H9L7.17 4H2v16h20V4h-5.17zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z",
  fill: "currentColor"
}));
export default SvgCameraAlt;